import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  APP_BUTTON_TYPES,
  isRunningInWebView,
  showAppButton
} from 'utils/webviewHelpers';

function NoInternetIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="201"
      height="167"
      fill="none"
      viewBox="0 0 201 167"
    >
      <ellipse
        cx="75.079"
        cy="120.288"
        fill="#333"
        rx="50.812"
        ry="10.634"
        transform="rotate(-.078 75.08 120.288)"
      />
      <path
        fill="#F2F2F2"
        stroke="#333"
        strokeDasharray="2.28 2.28"
        strokeLinejoin="round"
        strokeWidth="0.914"
        d="M98.088 108.888c-.54.414-1.125.828-1.767 1.244l-.248-.384q-.405.262-.84.526l-1.077.212.089.448-2.312.455-.088-.448-2.312.455.088.449-2.311.455-.088-.448-2.312.455.088.448-2.311.455-.089-.448-2.311.455.088.449-2.312.455-.088-.448-2.311.455.088.448-2.312.456-.088-.449-2.312.456.089.448-2.312.455-.088-.448-2.312.455.088.448-2.311.456-.088-.449-2.312.456.088.448-2.311.455-.089-.448-2.311.455.088.449-2.312.455-.088-.448-2.312.455.089.448-2.312.456-.088-.449-2.312.455.089.449-2.312.455-.088-.448-1.156.227-.012.003a4.5 4.5 0 0 1-.87.109l.012.457a4.9 4.9 0 0 1-1.892-.327l.164-.427a4.5 4.5 0 0 1-1.473-.931l-.315.332a4.9 4.9 0 0 1-1.107-1.569l.418-.185a4.5 4.5 0 0 1-.275-.832l-.253-1.127-.446.1-.507-2.254.445-.101-.507-2.254-.445.1-.508-2.254.446-.101-.507-2.254-.446.1-.507-2.254.446-.1-.507-2.255-.446.101-.507-2.255.446-.1-.508-2.254-.446.1-.507-2.255.446-.1-.507-2.254-.446.1-.507-2.254.446-.1-.507-2.255-.446.1-.507-2.254.445-.1-.507-2.255-.445.1-.508-2.254.446-.1-.507-2.255-.446.1-.507-2.254.446-.1-.507-2.254-.446.1-.507-2.255.446-.1-.508-2.254-.445.1-.508-2.254.446-.1-.507-2.255-.446.1-.507-2.254.446-.1-.507-2.255-.446.1-.507-2.254.445-.1-.507-2.254-.446.1-.507-2.255.446-.1-.507-2.254-.446.1L23.7 50.5l.446-.1-.507-2.255-.446.1-.507-2.254.445-.1-.507-2.255-.445.1-.508-2.254.446-.1-.507-2.255-.446.1-.507-2.254.446-.1-.254-1.127a4.5 4.5 0 0 1-.108-.87l-.457.012c-.017-.658.1-1.3.329-1.892l.426.164a4.5 4.5 0 0 1 .933-1.473l-.332-.315a4.9 4.9 0 0 1 1.57-1.107l.185.418a4.5 4.5 0 0 1 .832-.275l1.084-.244-.1-.446 2.168-.488.1.446 2.169-.489-.1-.446 2.167-.488.1.446 2.169-.489-.1-.446 2.167-.488.1.445 2.169-.488-.1-.446 2.167-.488.1.445 2.169-.488-.1-.446 2.168-.488.1.445 2.168-.488-.1-.446 2.168-.488.1.445 2.168-.488-.1-.446 2.168-.489.1.446 2.168-.488-.1-.446 2.168-.489.1.446L60 22.348l-.1-.446 2.168-.489.1.446 2.168-.488-.1-.446 2.168-.489.1.446 2.168-.488-.1-.446 2.168-.489.1.446.897-.202.74.48.25-.383 1.803 1.17-.249.383 1.804 1.17.249-.383 1.804 1.17-.249.383 1.804 1.17.249-.384 1.803 1.17-.248.383 1.803 1.17.25-.383 1.803 1.17-.249.383 1.804 1.17.249-.383 1.804 1.17-.249.383 1.804 1.17.248-.384 1.804 1.17-.248.383.743.482.192.901.447-.095.464 2.17-.447.096.464 2.171.447-.095.464 2.17-.447.096.463 2.171.447-.095.464 2.171-.447.096.464 2.17.447-.095.464 2.171-.447.096.464 2.17.447-.094.463 2.17-.447.096.464 2.171.447-.095.464 2.17-.447.096.464 2.171.447-.095.464 2.171-.447.095.464 2.171.446-.095.464 2.171-.447.096.464 2.17.447-.095.464 2.171-.447.096.464 2.17.447-.095.463 2.172-.447.095.464 2.171.447-.095.464 2.17-.447.096.464 2.171.447-.095.464 2.171-.447.096.463 2.17.447-.095.464 2.171-.447.096.464 2.17.447-.095.464 2.171-.447.096.464 2.171.447-.096.463 2.172-.447.095.183.857a40 40 0 0 0-.568.645l.346.299a47 47 0 0 0-1.371 1.674l-.359-.282a112 112 0 0 0-1.267 1.658l-.052.068.365.275c-.44.583-.872 1.154-1.318 1.717l-.358-.284c-.439.552-.89 1.094-1.376 1.63l.338.307a24 24 0 0 1-1.522 1.536l-.31-.336c-.494.456-1.031.91-1.626 1.365z"
      />
      <g fill="#202020" clipPath="url(#clip0_40519_25620)">
        <path d="M48.808 56.225a1.67 1.67 0 0 0-1.868 2.769l35.242 23.77a1.67 1.67 0 0 0 1.868-2.768l-10.404-7.018a1.67 1.67 0 0 0-.636-1.954 10 10 0 0 0-4.75-1.679l-4.323-2.916c3.608-.969 7.6-.427 10.94 1.826a1.67 1.67 0 1 0 1.868-2.77c-4.984-3.361-11.13-3.674-16.234-1.366l-3.057-2.062c6.24-3.85 14.336-3.737 20.857 1.003a1.67 1.67 0 0 0 1.963-2.702c-8.093-5.883-18.32-5.675-25.814-.32zM48.37 66.56a1.67 1.67 0 1 0 2.833 1.77 20 20 0 0 1 1.769-2.42l-2.784-1.877q-.977 1.18-1.818 2.528M55.501 67.616a17 17 0 0 0-1.938 2.376 1.67 1.67 0 0 0 2.769 1.867c.587-.87 1.26-1.65 1.998-2.335zM61.201 71.46a10 10 0 0 0-2.1 2.267 1.67 1.67 0 1 0 2.769 1.867 6.65 6.65 0 0 1 2.318-2.119zM68.045 82.609a3.34 3.34 0 1 1-1.275-6.557 3.34 3.34 0 0 1 1.275 6.557" />
      </g>
      <path
        fill="#fff"
        stroke="#333"
        strokeDasharray="1.83 1.83"
        strokeLinejoin="round"
        strokeWidth="0.914"
        d="m92.16 32.277-1.447-.944-.25.382-1.448-.944.25-.383-1.448-.944-.25.382-1.448-.944.25-.383-1.448-.944-.25.382-1.447-.944.25-.383-1.448-.944-.25.382-1.448-.944.25-.383-1.448-.944-.25.382-1.447-.944.25-.383-1.449-.944-.25.382-1.447-.944.25-.383L73.339 20l-.25.383-.724-.473a.45.45 0 0 0-.255-.077l-.008-.457a.93.93 0 0 0-.84.584l.424.167a.45.45 0 0 0-.016.266l.203.905-.445.1.407 1.81.446-.101.407 1.809-.446.1.407 1.81.446-.101.407 1.809-.445.1.407 1.81.446-.101.407 1.809-.446.1.408 1.809.445-.1.204.904c.089.395.252.752.47 1.061l-.373.264a3.44 3.44 0 0 0 2.22 1.404l.078-.45c.374.065.766.059 1.16-.03l.876-.197.1.446 1.75-.394-.1-.446 1.75-.394.1.446 1.75-.395-.1-.445 1.75-.394.1.445 1.751-.394-.1-.445 1.75-.394.1.445 1.75-.394-.1-.446.875-.196c.101-.023.176-.07.231-.127l.33.315a.93.93 0 0 0 .18-.997l-.42.18a.45.45 0 0 0-.171-.2l-.724-.472z"
      />
      <ellipse cx="132.673" cy="157.321" fill="#333" rx="52.212" ry="8.839" />
      <path
        fill="#F35D1D"
        stroke="#333"
        strokeWidth="0.914"
        d="M148.7 60.83a10.51 10.51 0 0 1 8.902 6.64l27.095 69.168a10.51 10.51 0 0 1-1.707 10.556l-4.276 5.137-87.223-12.686c-8.364-1.216-11.943-11.306-6.216-17.522l56.984-61.836z"
      />
      <path
        fill="#FB7137"
        stroke="#333"
        strokeWidth="0.914"
        d="M139.493 69.419c3.394-3.889 9.706-2.773 11.561 2.044l27.562 71.576c1.789 4.646-2.181 9.465-7.083 8.599l-78.767-13.926c-4.902-.867-6.98-6.755-3.706-10.506z"
      />
      <mask id="path-12-inside-1_40519_25620" fill="#fff">
        <path
          fillRule="evenodd"
          d="M153.203 66.855c-2.976-7.682-13.044-9.462-18.474-3.266l-52.187 59.557c-5.631 6.427-2.075 16.539 6.339 18.027l80.79 14.283c8.414 1.488 15.222-6.793 12.136-14.76zm-3.643 3.082c-1.978-5.138-8.711-6.328-12.331-2.18l-50.433 57.788c-3.507 4.019-1.282 10.327 3.97 11.256l78.767 13.925c5.253.929 9.506-4.234 7.59-9.212z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#FB7137"
        fillRule="evenodd"
        d="M153.203 66.855c-2.976-7.682-13.044-9.462-18.474-3.266l-52.187 59.557c-5.631 6.427-2.075 16.539 6.339 18.027l80.79 14.283c8.414 1.488 15.222-6.793 12.136-14.76zm-3.643 3.082c-1.978-5.138-8.711-6.328-12.331-2.18l-50.433 57.788c-3.507 4.019-1.282 10.327 3.97 11.256l78.767 13.925c5.253.929 9.506-4.234 7.59-9.212z"
        clipRule="evenodd"
      />
      <path
        fill="#333"
        d="m134.729 63.59-.687-.603zm18.474 3.265-.852.33zm-70.661 56.291.687.603zm6.339 18.027-.16.9zm80.79 14.283-.159.9zm12.136-14.76.852-.33zm-44.578-72.939-.688-.6zm12.331 2.18.853-.328zm-62.764 55.608.689.601zm3.97 11.256.16-.9zm78.767 13.925-.159.9zm7.59-9.212-.853.328zm-41.707-77.322c4.978-5.68 14.207-4.049 16.935 2.994l1.704-.66c-3.224-8.324-14.131-10.252-20.013-3.539zm-52.187 59.557 52.187-59.557-1.374-1.205-52.187 59.557zm5.81 16.524c-7.712-1.364-10.972-10.634-5.81-16.524l-1.374-1.205c-6.1 6.962-2.249 17.917 6.867 19.529zm80.792 14.283L89.04 140.273l-.318 1.8 80.79 14.283zm11.124-13.53c2.829 7.303-3.412 14.894-11.124 13.53l-.319 1.8c9.116 1.611 16.491-7.359 13.147-15.99zm-28.604-73.84 28.604 73.84 1.704-.66-28.604-73.84zm-14.433 1.172c3.167-3.63 9.058-2.588 10.789 1.907l1.706-.656c-2.226-5.78-9.8-7.12-13.872-2.453zm-50.433 57.788 50.433-57.788-1.377-1.202-50.433 57.788zm3.44 9.755c-4.551-.805-6.48-6.272-3.44-9.755l-1.377-1.202c-3.976 4.555-1.453 11.704 4.5 12.757zm78.767 13.925-78.766-13.925-.318 1.8 78.766 13.925zm6.578-7.984c1.661 4.314-2.025 8.789-6.578 7.984l-.318 1.8c5.953 1.053 10.774-4.799 8.601-10.441zm-27.563-71.577 27.563 71.577 1.705-.657-27.562-71.576z"
        mask="url(#path-12-inside-1_40519_25620)"
      />
      <path
        fill="#E54500"
        d="m140.378 91.444-3.487 29.802 4.126-1.893 3.23-29.466z"
      />
      <path
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.914"
        d="m134.503 90.773 5.763.674m-5.763-.674 4.164-1.591 5.673.663m-9.837.928-3.486 29.789 5.763.675m3.486-29.79 4.074-1.602m-4.074 1.602-3.486 29.79m7.56-31.392-3.461 29.578-4.099 1.814"
      />
      <path
        fill="#E54500"
        d="m136.182 127.271-.593 5.058 4.021-3.275.579-4.951zM139.941 123.965l-3.804 3.205-5.711-.668 4.168-3.163z"
      />
      <path
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.914"
        d="m130.306 126.63 5.763.675m-5.763-.675 4.207-3.325 5.673.663m-9.88 2.662-.586 5.015 5.763.674m.586-5.014 4.117-3.337m-4.117 3.337-.586 5.014m4.703-8.351-.604 5.167-4.099 3.184"
      />
      <defs>
        <clipPath id="clip0_40519_25620">
          <path
            fill="#fff"
            d="M42 53.648 81.342 46l7.01 36.064-39.342 7.648z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function InternetNotConnected() {
  const isWebViewPresent = isRunningInWebView();
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.internetNotConnected'
  });

  useEffect(() => {
    if (isRunningInWebView()) {
      showAppButton(APP_BUTTON_TYPES.CLOSE);
    }
  }, [isRunningInWebView]);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      height={isWebViewPresent ? '100vh' : '80%'}
      maxHeight="100vh"
      gap={2}
    >
      <NoInternetIcon />
      <Typography variant="titleMedium" textAlign="center">
        {t('recheckInternetText')}
      </Typography>
    </Stack>
  );
}

export default InternetNotConnected;
